var productItem = {
  data: () => ({
    product: {},
  }),
  computed: {
    
    amount(){

      return this.getAmount(this.product)
    },
    name(){
      this.product.$name =  this.getName(this.product)
      return this.product.$name
    },
    subname(){
      return this.subName(this.product)
    },
    quantity: {
      get() {
        
        return this.product.$quantity || this.product.count || 1;
      },
      set(value) {
        this.$set(this.product, "$quantity", value);
      },
    },
    description: {
      get() {
        if (!this.product) return ''
        return this.product.$description || '';
      },
      set(value) {
        this.$set(this.product, "$description", value);
      },
    },
    variation: {
      get() {
        return this.product.$variation || null;
      },
      set(value) {
        this.$set(this.product, "$variation", value);
      },
    },
    volume: {
      get() {
        return this.product ? this.product.$volume || null : null;
      },
      set(value, old) {
        this.$set(this.product, "$volume", value);
      },
    },
    
    includelist(){
        if (!this.product || !this.product.add) return false
        let arr = []
        this.product.add.filter(p=>!p.extra).map(add=>{
          if (Array.isArray(add.value)) {
            arr = arr.concat(add.value)
          }else if (add.value){
            arr.push(add.value)
          }
        })
        return arr//this.products.filter(p=>arr.includes(p._id))
    },
    extralist(){
      if (!this.product || !this.product.add) return false
      let arr = []
      this.product.add.filter(p=>p.extra).map(add=>{
        if (Array.isArray(add.value)) {
          arr = arr.concat(add.value)
        }else if (add.value){
          arr.push(add.value)
        }
      })
      return arr//this.products.filter(p=>arr.includes(p._id))
  },
    addOneClick() {
      return (
        !this.product.$_id &&
        !this.product.valiation &&
        !this.product.add &&
        !this.product.volume &&
        !this.product.extra
      );
    },
    isComplete() {
      let valid = true;
      let arr = this.product.add || [],
        include = this.product.$include || [];
      if (
        this.product.volume &&
        this.product.volume.length > 0 &&
        !this.product.$volume
      )
        valid = false;
      if (
        this.product.variation &&
        this.product.variation.length > 0 &&
        !this.product.$variation
      )
        valid = false;
      arr
        .filter((a) => a.min || a.max)
        .map((a) => {
          let count = include.filter((i) => i.group == a.group).length;
          if (count < a.min || count > a.max) valid = false;
        });
      return valid;
    },
  },
  methods: {
    getINcludeInfo(item, source) {
      let incl = item.$include || this.clone(item.include) || [];
      if (source) incl = this.clone(item.include) || [];
      if (incl)
        incl.map((i) => {
          let a = item.add.filter((a) => a.group == i.group)[0];
          return Object.assign(i, a || {});
        });
      return incl;
    },
    loadProduct(item, add) {
      if (!item) return null;
      let incl = item.$include || this.clone(item.include) || [];
      
      if (item.add) item.add.map(a=>{
        a.value = incl.filter(i=>i.group == a.group)//.map(i=>i._id)
        //if (a.max==1) a.value = a.value[0]
       })
      /*if (incl)
        incl.map((i) => {
          let a = item.add.filter((a) => a.group == i.group)[0];
          return Object.assign(i, a || {});
        });*/
      item = Object.assign(item, {
        $quantity: item.count || item.$quantity || item.quantity|| 1,
        $volume: item.$volume, // || (item.volume) ? Object.keys(item.volume)[0]: null,
        $variation: item.$variation,
        $extras: item.$extras || [],
        $include: item.$include || this.getINcludeInfo(item),
        $include2: item.$include2 || [],
        $half: item.$half,
        $favorite: 0,
        $description: item.$description || null,
      });
      if (item.volume && !item.$volume && add) item.$volume = item.volume[0];
      if (item.variation && !item.$variation && add)
        item.$variation = item.variation[0];
      return this.setProduct(item);
    },
    setProduct(item, quantity, noAssign) {
      //if (item.$description) item.$description = item.$description.replace('Half om Half ','')
      //if (item.$half) item.$description = 'Half om Half ' + (item.$description ? item.$description : '')
      item.$quantity = quantity || item.count || item.$quantity ||  1;
      if (item.delete == true) item.$quantity = 0;
      item.$name = this.getName(item);
      item.$subname = this.subName(item);
      item.$subprice = this.subPrice(item);
      item.$price = this.getPrice(item);
      item.$amount = this.getAmount(item);
      //if (!noAssign) this.product = item
      return item;
    },
    calculateProduct(item) {
      item.$subprice = this.subPrice(item);
      item.$price = this.getPrice(item);
      item.$amount = this.getAmount(item);
      //this.product = item
      return item;
    },
    getName(item) {
      let n = [];
      if (item.$volume && item.$volume.count > 1)
        n.push(item.$volume.count + "x");
      if (item.$volume) {
        item.name = item.name.replace(item.$volume.name + " ", ""); //HACK fix double name if extra
        n.push(item.$volume.name);
      }
      n.push(item.name);
      if (item.$variation) n.push(item.$variation);

      if (item.$extra) item.$extra.filter(e=>e._single).map(e=>n.push(e.name))
      return n.join(" ");
    },
    subName(item) {
      let items = item.$include || [];
      let include = this.getINcludeInfo(item, true);
     
      //if (item.$volume) items = items.filter(i=>i.name!=item.$volume.name)
      let isMax = include.filter((i) => i.max == 99 || i.exception).length > 0;
      let p = include
        .filter((i) => i.name && (i.max == 99 || i.exception))
        .map((i) => i.name); //HACK 99 exluding
      
        //let pex = items.filter((i) => i.name).map((i) => i.name); //HACK  && i.group =='Toppings'
      let oi = items
        .filter((i) => i.name && !i.extra)
        .map((i) => {
          let name = i.count > 1 ? i.count + "x " + i.name : "" + i.name;
          return name;
        });
      let oiextra = items
        .filter((i) => i.name && i.extra)
        .map((i) => {
          let name = i.count > 1 ? i.count + "x " + i.name : "" + i.name;
          return name;
        });
      let oi2 = items.filter((i) => i.name).map((i) => i.name);
      let exclude = p.filter((f) => !oi2.includes(f)).join(", zonder "); //&& pex.includes(f)
      let met = oi.filter((f) => !p || !p.includes(f)).join(", "); // (!p.includes(f.count + 'x ' + f.name) && !p.includes(f.name ))
      let extra = oiextra.filter((f) => !p || !p.includes(f)).join(", ");
      let tt = [];
      if (isMax && met) tt.push("Met");
      if (met) tt.push(met); //(item.$include||[]).filter(i=>extra.includes(i.name) || i.count>1).map(i=>(i.count>1) ? i.count + 'x ' + i.name : '' + i.name).join(', '))
      if (exclude) tt.push("zonder " + exclude);
      if (extra) tt.push((met ? ", extra " : "Extra ") + extra); //(item.$include||[]).filter(i=>extra.includes(i.name) || i.count>1).map(i=>(i.count>1) ? i.count + 'x ' + i.name : '' + i.name).join(', '))
      if (this.half && item.$include2 && item.$include2.length > 0)
        return (
          "Half " +
          oi2.join(" ") +
          " / Half " +
          item.$include2.map((i) => i.name).join(" ")
        );
        let subname = tt.join(" ");
        subname = subname.replace(/Geen /g, 'Zonder ').replace(/Met Zonder/g, 'Zonder').replace(/Met zonder/g, 'zonder')
      return subname
    },
    subPrice(item) {
      let price = 0;
      let discount = {};
      if (item.add)
        item.add
          .filter((ii) => ii.included)
          .map((i) => (discount[i.group] = i.included));
      if (item.$include) {
        item.$include.map((i) => {
          let count = i.count || 1;
          if (discount[i.group] > 0) {
            count -= discount[i.group];
            discount[i.group] -= i.count || 1;
          }
          if (i.tab == "extra") i.extra = false;
          if (!i.price) i.price = 0;
          let quantity = item.$quantity || item.count || item.quantity || 1;

          if (count > 0 && i.price > 0 && i.extra)
            price += (i.price * count) / quantity;
          if (count > 0 && !i.extra) price += i.price * count;
        });
      }

      if (item.$include2)
        item.$include2.map((i) => {
          if (i.price > 0) price += i.price * (i.count || 1);
        });
      if (item.include)
        item.include.map((i) => {
          if (i.price > 0) price -= i.price * (i.count || 1);
        });
      if (price < 0) return 0;
      return price || 0;
    },
    extraPrice(item) {
      let price = 0;
      if (this.extralist)
      this.extralist.map((i) => {
          if (i.price > 0) price += i.price * (i.count || 1);
        });
      return price || 0;
    },
    getPrice(item) {
      if (item.$volume && item.$volume.price > 0) return item.$volume.price;
      if (
        this.deliver == true &&
        item.$price_deliver &&
        item.$price_deliver <= item.price
      )
        return item.$price_deliver || 0;
      if (
        this.deliver == false &&
        item.$price_takeout &&
        item.$price_takeout <= item.price
      )
        return item.$price_takeout || 0;

      return item.price || 0;
    },
    getAmount(item) {
      //this.$nextTick(()=>{
      if (!item) item = this.product
      if (!item) return false
      //if ((item.$price == 0 || item.price == 0) && item.$amount > 0)
      //  return item.$amount || 0;
      return item.$quantity * (this.getPrice(item) + this.subPrice(item)) || 0;
      //})
    },
  },
};

/*class productItem {
    constructor(item,deliver) {
        this.deliver = deliver ? true : false
       
        };
        data(){
            return item
        }
        
}*/
export default productItem;
